module.exports = __webpack_public_path__ + "static/img/person_info_bg.194c9149.png";